import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'
import firebaseSettings from '@/../firebase.json'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
}

// Initialize Firebase
export function getFirebaseApp() {
  const firebaseApp = initializeApp(firebaseConfig)
  const auth = getAuth(firebaseApp)
  const db = getFirestore(firebaseApp)
  if (process.env.NODE_ENV === 'development') {
    connectAuthEmulator(auth, 'http://' + firebaseSettings.emulators.auth.host + firebaseSettings.emulators.auth.port)
    connectFirestoreEmulator(db, firebaseSettings.emulators.firestore.host, firebaseSettings.emulators.firestore.port)
  }
  return { firebaseApp, auth }
}